/** Technical shell commit, independent of product analytics and page render invocation. */
import { useLayoutEffect } from 'react'
import { startupTimingSchema, type StartupTiming } from '../../../src/shared/startup-timing-contract'
import { commitShopifyStartup } from '../../startupTiming'
import { captureShopifyDiagnosticScope, shopifyApiFetch, type ShopifyAppBridge } from '../../shopifyApiFetch'

function deliveryFailed() {
  console.error('SHOPIFY_STARTUP_TIMING_DELIVERY_FAILED')
}

export function useShopifyStartupCommit(
  shopify: ShopifyAppBridge,
  shop: string | null,
  content: StartupTiming['content'],
) {
  useLayoutEffect(() => {
    if (!shop) return
    const diagnosticScope = captureShopifyDiagnosticScope(shopify)
    if (diagnosticScope.sessionIdentity?.shopDomain !== shop) return
    commitShopifyStartup(content, (report) => {
      const checked = startupTimingSchema.safeParse(report)
      if (!checked.success) {
        deliveryFailed()
        return
      }
      // Same App Bridge intercepted transport and immutable verified scope as UI diagnostics.
      // Intake is not in the observed route list, so delivery cannot recursively report itself.
      void shopifyApiFetch(shopify, '/api/client-diagnostics', {
        diagnosticScope,
        init: {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ kind: 'startup-timing', report: checked.data }),
          keepalive: true,
        },
      })
        .then((response) => {
          if (!response.ok) deliveryFailed()
        })
        .catch(deliveryFailed)
    })
  }, [shopify, shop, content])
}
